// extracted by mini-css-extract-plugin
export default {"Titulo":"error-page_Titulo__Vk8N7","Centro":"error-page_Centro__xu9vw"};